const SET_PICSRC = 'SET_PICSRC' // 首导页
const SET_DICT = 'SET_DICT' // 字典
const SET_INFORM = 'SET_INFORM' // 字典
const state = {
  versionNo: '1.0.1',
  ismode: process.env.NODE_ENV === 'production' ? 1 : 0,
  baseURL: process.env.NODE_ENV === 'production' ? process.env.prop_url : process.env.dev_url,
  // baseURL: process.env.NODE_ENV ===  process.env.dev_url,
  picsrc: 'http://180.97.195.59:9000', 
  dictTypes: {},
  inform: [] // 通知消息列表
}
const mutations = {
  [SET_PICSRC](state, src) {
    state.picsrc = src
  },
  [SET_DICT](state, dict) {
    state.dictTypes = dict
  },
  [SET_INFORM](state, data, type) {
    var arr = JSON.parse(JSON.stringify(state.inform))
    if (type) {
      arr.push('1')
      state.inform = arr
    } else {
      console.log('shanchu')
    }
  }
}
export default {
  state,
  mutations
}
